import React from "react"

// eslint-disable-next-line no-unused-vars
import Styles from "./styles/index.scss"

/* Use Section here instead of on each block ? */

/**
 * DefaultLayout - Layout container for site
 * @param {object} props - react props
 */
const DefaultLayout = props => {
  const { children } = props

  return <>{children}</>
}

export default DefaultLayout
